import React from 'react'
import parse from 'html-react-parser'

const TitleContent = ({title, content, alignment, rightPosition, seo}) => {

  return (
    <section className={`basic-content basic-content--${alignment} ${rightPosition ? 'basic-content--right' : ''} ${seo ? 'basic-content--seo' : ''}`}>
      <div className="basic-content__inner">
        <div className="basic-content__wrapper" data-sal='slide-up' data-sal-duration='1000' data-sal-delay='0' data-sal-easing='ease'>
          {title && <h3 className={!content ? 'basic-content__no-content' : ''}>{title}</h3>}
          { content && <div>{parse(content)}</div> }
        </div>
      </div>
    </section>
  )
}

export default TitleContent